import React, { lazy, Suspense, useEffect, useState } from "react";
import { HomePage } from "./pages/Home";
import { About } from "./pages/About";
import { Services } from "./pages/Services";
import BlogList from "./pages/Blog/BlogList";
import BlogPost from "./pages/Blog/BlogPost";
import { EtlynCms, Page } from "@etlyn/etlyn-cms";
import { Header } from "./components/Header";
import Privacy from "./pages/Privacy/Privacy";
import { ReviewSubmission } from "./pages/ReviewSubmission";
import { internalCmsBilling } from './billing';

const GamePage = lazy(() => import('./pages/Game/GamePage'));

function App() {
  const [device, setDevice] = useState("web");
  const adventurePath = window.location.pathname.replace(/\/+$/, '');

  useEffect(() => {
    if (window.screen.width < 768) {
      setDevice("mob");
    }
  }, []);

  // Vercel redirects old bookmarks; keep the same canonical URL in local previews.
  useEffect(() => {
    if (adventurePath === '/game') {
      window.history.replaceState(window.history.state, '', `/4u${window.location.search}${window.location.hash}`);
    }
  }, [adventurePath]);

  // The little adventure has its own full-screen scene and needs no CMS session.
  // Keep Three.js and its assets out of the marketing pages' initial bundle.
  if (adventurePath === '/4u' || adventurePath === '/game') {
    return (
      <Suspense fallback={<div role="status" style={{ minHeight: '100svh', display: 'grid', placeItems: 'center', background: '#f6ede3', color: '#54473f' }}>Preparing a little adventure…</div>}>
        <GamePage />
      </Suspense>
    );
  }
  
  return (
    <EtlynCms header={<Header device={device} />} billing={internalCmsBilling}>
      <Page route="/" component={<HomePage />} />
      <Page route="/home" component={<HomePage />} />
      <Page route="/about" component={<About />} />
      <Page route="/services" component={<Services />} />
      <Page route={"/blogs"} component={<BlogList />} />
      <Page route="/blogs/:blogSlug" component={<BlogPost />} />
      <Page route="/privacy" component={<Privacy />} />
      <Page route="/review/:token" component={<ReviewSubmission />} />
    </EtlynCms>
  );
}

export default App;
